var spoiler_default = {
  "fontElementMap": "RPTfD",
  "hideText": "kA-24",
  "onHoverText": "r0z5y",
  "hideBlock": "YCL4H",
  "smallBlur": "_32RTd",
  "mediumBlur": "_7Mpmg",
  "largeBlur": "K7qCs",
  "hideBlock_gallery": "wZSQb",
  "overlay": "_0Za4N",
  "overlay_gallery": "DlmF6",
  "revealSpoilerBtn": "Hl-iI",
  "isMobile": "JjB0o",
  "onHoverBtn": "LZVlC",
  "spoilerWrapper": "_2rLVo",
  "spoilerDescription": "_8Fl36",
  "spoilerContainer": "g2G9p",
  "spoilerContainer_Gallery": "AOk-X"
};
export {
  spoiler_default as default
};
//# sourceMappingURL=spoiler-scss.js.map
